import { defineMessages } from 'react-intl';

export default defineMessages({
    brokerFees: {
        id: 'wmic-pe-capability-gateway-common-react.BrokerFees.Broker Fees',
        defaultMessage: 'Broker Fees'
    }
});
